import { Alert, Box, Divider, Grid, Typography } from '@mui/material'
import { Category, categoryFromJSON, GlobalNotificationProto, GlobalNotificationType } from '../../../proto/generated/global-notification'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { selectGlobalNotifications } from '../../../selectors/globalNotification'
import EmptyGlobalNotificationView from '../EmptyGlobalNotificationView/EmptyGlobalNotificationView'
import { useStyles } from './styles'

const CATEGORY_TO_SEVERITY: Record<Category, 'info' | 'warning' | 'error'> = {
    [Category.CATEGORY_UNKNOWN]: 'info',
    [Category.INFO]: 'info',
    [Category.WARN]: 'warning',
    [Category.ERROR]: 'error',
    [Category.UNRECOGNIZED]: 'info'
}

const SystemNotifications = () => {
    const notifications: GlobalNotificationProto[] = useSelector(selectGlobalNotifications)
    const [expandedMap, setExpandedMap] = useState<Record<string, boolean>>({})
    const { classes } = useStyles()

    const systemNotifications = notifications.filter((notification) => notification.type === GlobalNotificationType.SYSTEM_NOTIFICATION && notification.enabled).sort((a, b) => b.updatedAt - a.updatedAt)

    return (
        <Grid container sx={{ flex: systemNotifications.length > 0 ? 0 : 1, display: 'flex', flexDirection: 'row' }}>
            {systemNotifications.length > 0 ? (
                systemNotifications.map((notification: any) => {
                    const categoryEnum = categoryFromJSON(notification.category)
                    const severity = CATEGORY_TO_SEVERITY[categoryEnum] || 'info'

                    return (
                        <Grid item xs={12} key={notification.id} padding={0}>
                            <Alert severity={severity} sx={{ color: 'inherit', background: 'none', boxShadow: 'none', '& .MuiAlert-icon': { marginRight: '7px' } }}>
                                <Typography fontWeight="bold" >
                                    {notification.header}
                                </Typography>
                                <Typography
                                    className={`${classes.notificationText} ${expandedMap[notification.id] ? classes.expanded : classes.collapsed}`}
                                >
                                    {notification.message}
                                </Typography>

                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    {notification.message && notification.message.length > 100 && !expandedMap[notification.id] && (
                                        <Typography
                                            component="span"
                                            color="inherit"
                                            fontSize={'0.75rem'}
                                            sx={{ cursor: 'pointer', fontWeight: 'bold' }}
                                            onClick={() => setExpandedMap((prev) => ({ ...prev, [notification.id]: true }))}
                                        >
                                            {' Read more'}
                                        </Typography>
                                    )}

                                    {notification.message && notification.message.length > 100 && expandedMap[notification.id] && (
                                        <Typography
                                            component="span"
                                            color="inherit"
                                            fontSize={'0.75rem'}
                                            sx={{ cursor: 'pointer', fontWeight: 'bold' }}
                                            onClick={() => setExpandedMap((prev) => ({ ...prev, [notification.id]: false }))}
                                        >
                                            {' Show less'}
                                        </Typography>
                                    )}
                                </Box>

                                <span style={{ fontSize: '0.75rem' }}>{dayjs(notification.updatedAt).format('DD-MM-YYYY HH:mm A')}</span>
                            </Alert>
                            <Divider key={`divider-${notification.id}`} />
                        </Grid>
                    )
                })
            ) : (
                <Grid container sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                        <EmptyGlobalNotificationView />
                    </Box>
                </Grid>
            )}
        </Grid>
    )
}

export default SystemNotifications
